import { FlightEvaluationRepository } from '@src/main/modules/reports/flight/domain/flight-evaluation.repository';
import {
  BriefFlightEvaluation,
  EvaluationCriteria,
} from '@src/main/modules/reports/shared/domain/evaluation.interface';
import { parseEvaluationCriteria } from '@src/main/modules/reports/shared/infrastructure/mapper/evaluation-criteria.mapper';
import { api, TokenProvider } from '@src/main/shared/infrastructure/entity/axios';
import { PageResponse } from '@src/main/shared/infrastructure/entity/page.entity';

const path = '/flight-evaluations';

export const createFlightEvaluationHttpRepository = (
  tokenProvider: TokenProvider,
): FlightEvaluationRepository => new FlightEvaluationHttpRepository(tokenProvider);

class FlightEvaluationHttpRepository implements FlightEvaluationRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  private async getAuthToken(): Promise<string> {
    const token = await this.tokenProvider.getToken();
    if (!token) {
      throw new Error('Authentication token is missing');
    }
    return token;
  }

  async findByCriteria(
    criteria: EvaluationCriteria,
  ): Promise<{ items: BriefFlightEvaluation[]; total: number }> {
    const token = await this.getAuthToken();
    const params = parseEvaluationCriteria(criteria);
    const response = await api.get<PageResponse<BriefFlightEvaluation>>(
      `${path}/all`,
      token,
      params,
    );
    return {
      items: response.items,
      total: response.total,
    };
  }

  async downloadPdf(evaluationId: string): Promise<Blob> {
    const token = await this.getAuthToken();
    return await api.fetchBlob(`${path}/${evaluationId}/pdf`, token);
  }

  async softDelete(evaluationId: string): Promise<void> {
    const token = await this.getAuthToken();
    await api.patch(`${path}/${evaluationId}/soft`, token, {});
  }
}
